 'use strict';

 let themes = require('../../../../../common/data/themes');

module.exports = function(angularModule) {
  angularModule.controller('EmailTemplateEditorCtrl', function(
      $scope, $state, $stateParams, reviewGenService, $log, stringService, updateService,
      accountsService, pageInfo, onComplete, imageManagerService, $uibModal, isSharedDefault, user) {

    var vm = this;
    this.sampleEmails = require('../defaultEmailTemplates');
    vm.placeholderLogo = this.sampleEmails[0].dynamicFields['image:logo'];
    vm.isFormDirty = true;
    vm.activeTab = 'preview';
    vm.themes = themes;
    vm.showVisibility = isSharedDefault || _.includes(user.permissions, 'ReviewBuilderVisibilityAdmin');

    vm.accountConfig = {
      required : true,
      accountId : null,
      disableDropdown: vm.mode === "edit",
      showAccountSelection: false,
      editPage: true
    };

    vm.mode = pageInfo.mode;
    vm.state = 'Loading';

    vm.selectedEmailTemplate = {
      id : vm.mode === "create" ? null : $stateParams.templateId
    };

    if ($stateParams.template) {
      let template = angular.copy($stateParams.template);
      processSuccessfulLoad(template)
    } else {
      reviewGenService.getEmailTemplates(vm.selectedEmailTemplate.id).then(processSuccessfulLoad);
    }

    vm.onEditorLoaded = function(editor) {
      editor.setTheme("ace/theme/chrome")
      editor.getSession().setMode("ace/mode/handlebars")
      editor.setShowPrintMargin(false)
      editor.$blockScrolling = Infinity
      vm.editor = editor
    };

    vm.pageStrings = stringService.adminStrings(vm.mode);

    function processSuccessfulEmailTemplate(response) {
      var updateInfo = {
        status: "Active",
        type: "emailTemplate",
        title: "Email Template",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action: vm.mode}],
        entity: vm.emailTemplate,
        id: vm.emailTemplate._id,
        name: vm.emailTemplate.name,
        accountId: accountsService.getCurrentAccount(),
        searchParam: vm.emailTemplate.name
      };
      updateService.registerSuccessfulUpdate(updateInfo, true);
      onComplete.resolve(response.data);
    }

    function processSuccessfulLoad(resp) {
      vm.state = "EmailTemplateEditing";

      vm.emailTemplate = resp;
      if (vm.mode === 'create') {
        delete vm.emailTemplate._id;
        vm.emailTemplate.isShared = isSharedDefault;
      }
      if ($stateParams.copy) {
        vm.emailTemplate.name = "Copy of " + vm.emailTemplate.name;
      }
      if (vm.emailTemplate.theme) {
        vm.colorTheme = _.find(themes, {name: vm.emailTemplate.theme});
      }
    }

    function handleError(response) {
      var errorDetail = 'Please contact support';

      if(response.data && response.data.error.code) {
        var errorCode = response.data.error.code;

        if(errorCode === 'reviewForm.edit.emailTemplateName.duplicate'){
          errorDetail = 'This email template name already exists. Email template names must be unique.';
        }
      }

      vm.errorMsg = 'Error '+vm.pageStrings.errorAction+' Email template!';
      vm.errorDetail = errorDetail;
      vm.state = 'EmailTemplateEditing';
    }


    vm.createEditEmailTemplate = function() {
      vm.state = 'PendingConfirmation';
      vm.formSubmitted = true;

      if (!vm.editForm.$valid) {
        $log.info('Missing Template data');
        return;
      }

      var templateId = $stateParams.templateId;
      if ($stateParams.copy || vm.mode === 'create') {
        templateId = false;
      }

      vm.emailTemplate.templateType = "email";

      reviewGenService.saveEmailTemplate(templateId, vm.emailTemplate)
        .then(processSuccessfulEmailTemplate).catch(handleError);
    };


    vm.cancel = function(){
      onComplete.reject();
    };

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    function previewForm() {
      vm.previewLoading = true;
      reviewGenService.previewEmailTemplate(vm.emailTemplate).then(function(response) {
        vm.isFormDirty = false;
        var template = response.data;
        var iframe = $("#previewForm")[0], iframedoc = iframe.contentDocument || iframe.contentWindow.document;

        iframedoc.open();
        iframedoc.write(template);
        iframedoc.close();
      }).finally(() => vm.previewLoading = false);
    }

    vm.previewForm = _.debounce(previewForm, 400);
    $scope.$watch("vm.emailTemplate.content", function(newVal, oldVal) {
      recalculateDynamicFields();
      if (newVal !== oldVal) {
        vm.isFormDirty = true;
        vm.previewForm();
      }
    });

    vm.triggerEditorRefresh = function(){
      if(vm.emailTemplate.content){
        vm.editor.setValue(vm.emailTemplate.content);
      }
    };

    vm.selectSample = function(name) {
      reviewGenService.getEmailTemplates(name).then(function(response) {
        vm.emailTemplate.content = response.content;
      });
    };

    function recalculateDynamicFields() {
      if (!vm.emailTemplate) {
        return;
      }
      vm.dynamicFields = [];
      let dynamicFieldRegex = /{{\s*dynamicField:([^ }]+)\s*}}/g, result;
      while (result = dynamicFieldRegex.exec(vm.emailTemplate.content)) {
        imgResult = null;
        textResult = null;
        var imageUploadRegex = /image:([^ }]+)/g, imgResult;
        var textRegex = /text:([^ }]+)/g, textResult;
        imgResult = imageUploadRegex.exec(result[1]);
        textResult = textRegex.exec(result[1]);
        if (imgResult !== null && notAlreadyAdded("image:",imgResult[1])) {
          vm.dynamicFields.push(["image:", imgResult[1]])
          initializeImageNames("image:" + imgResult[1])
          addPlaceholderLogoIfEmpty("image:" + imgResult[1]);
        }
        else if (textResult !== null && notAlreadyAdded("text:",textResult[1])) {
          vm.dynamicFields.push(["text:", textResult[1]]);
        }
      }
    }

    function notAlreadyAdded(key,value) {
      return !vm.dynamicFields.find(fieldObj => (fieldObj[0]===key && fieldObj[1]===value))
    }

    function addPlaceholderLogoIfEmpty(key) {
      if((!vm.emailTemplate.dynamicFields[key] || vm.emailTemplate.dynamicFields[key] == "") && key=="image:logo"){
        vm.emailTemplate.dynamicFields[key] = vm.placeholderLogo;
      }
    }

    function initializeImageNames(fieldName) {
      imageManagerService.listImages().then(images => {
        vm.imageArray[fieldName] = _.findWhere(images, { url : vm.emailTemplate.dynamicFields[fieldName] })
      })
    }

    vm.imageSelected = function(fieldName) {
      return function(image) {
        vm.emailTemplate.dynamicFields[fieldName] = image.url;
        vm.imageArray[fieldName] = image
        vm.triggerEditorRefresh()
        previewForm()
      }
    }

    vm.deselectImage = function(field){
      vm.imageArray[field[0] + field[1]] = null;
      vm.emailTemplate.dynamicFields[field[0]+field[1]] = "";
      recalculateDynamicFields();
      vm.triggerEditorRefresh()
      previewForm()
    }

    vm.imageArray = {};

    resetState(false);

    updateCurrentStep(0);

    function updateCurrentStep(step){
      $scope.currentStep = step;
    }

    function resetState(useInterruptFlag){
      $scope.errorMsg = "";
      $scope.failedUpload = false;
      $scope.failedSave = false;
      $scope.tmpLogoUrl = null;
      $scope.savingLogo = false;
      $scope.fileUploading = false;
      if(useInterruptFlag){
        $scope.interruptFlag = true;
      }
    }

    $scope.openLogoUploadModal = function(){
      let modalInstance = $uibModal.open({
        template: require('../../../../../common/imageUpload/imageUploadModal.html'),
        size: 'md',
        controller: "ImageUploadModalCtrl",
        resolve: {
          imageType : () => "Logo"
        }
      });

      modalInstance.closed.then(() => {
        if($scope.currentStep === 2){
          $window.location.reload();
        }
      })
    }

    $scope.saveLogo = function(){
      $scope.savingLogo = true;
      configService.saveImage($scope.tmpLogoUrl,"Logo").then(function(resp){
        $scope.savingLogo = false;
        updateCurrentStep(2);
      },function(){
        $scope.savingLogo = false;
        $scope.failedSave = true;
      });
    }

    vm.pushCssConfig = function() {

      console.log(vm.colorTheme)

      var templateDoc = new DOMParser().parseFromString(vm.emailTemplate.content, 'text/html');
      templateDoc.body.querySelectorAll('.email-header').forEach(function(x) {x.style.backgroundColor = vm.colorTheme.fill})
      templateDoc.body.querySelectorAll('.header-tab').forEach(function(x) {x.style.backgroundColor = vm.colorTheme.fill})
      templateDoc.body.querySelectorAll('.call-to-action').forEach(function(x) {x.style.backgroundColor = vm.colorTheme.fill})
      templateDoc.body.querySelectorAll('.call-to-action').forEach(function(x) {x.style.background = vm.colorTheme.fill})
      templateDoc.body.querySelectorAll('.call-to-action-mso').forEach(function(x) {x.style.fill =  vm.colorTheme.fill})
      templateDoc.body.querySelectorAll('.call-to-action-mso').forEach(function(x) {
        console.log(x)
      })
      templateDoc.body.querySelectorAll('.footer').forEach(function(x) {x.style.background = vm.colorTheme.fill})

      var serializeDoc = (doc) => `<!DOCTYPE html>
<html>
    <head>${doc.head.innerHTML}</head>
    <body>${doc.body.innerHTML}</body>
</html>
`;

      vm.emailTemplate.content = serializeDoc(templateDoc)

      vm.isFormDirty = true;
      vm.previewForm();
    };
  });
};

